<template>
  <div class="share-box" @click="shareFun">
    <span class="share">分享</span>
    <span class="iconfont icon-fenxiang"></span>
    <div class="shareList" v-if="showShareTools == true">
      <span class="iconfont icon-weixin_circle" @click="wxShare"></span>
      <span class="iconfont icon-sign_qq" @click="qqShare"></span>
    </div>

     <!--微信分享二维码-->
    <div class="wx-share-box" v-show="showWxQrcode == 1">
      <div class="qrcode">
        <div class="close" @click="closeClick">
          <span class="iconfont icon-times"></span>
        </div>
        <div class="title">微信扫码分享</div>
        <div id="weixinShareQrcode" ref="weixinShareQrcode"></div>
        <div class="desc">使用手机微信扫码分享</div>
      </div>
    </div>

  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data(){
    return{
      showShareTools:false,
      showWxQrcode:0,//显示微信分享二维码
    }
  },
  methods: {
    //关闭微信二维码弹框
    closeClick:function(){
      this.$refs.weixinShareQrcode.innerHTML = ""; //清空生成的二维码
      this.showWxQrcode = 0
    },
    shareFun: function() {
      this.showShareTools = !this.showShareTools;
    },    
    //微信分享
    wxShare: function() { 
      //生成分享二维码
      new QRCode(this.$refs["weixinShareQrcode"], {
        text: 'https://h5.qishanzy.com/#/pages/course/detail?id='+this.$route.path,
        width: 260,
        height: 260,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
      this.showWxQrcode = 1 
    },
    //qq分享
    qqShare: function() {
      window.open('https://connect.qq.com/widget/shareqq/index.html?url='+document.location.href, 'newwindow', 'height=800, width=1000, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no')
      return;
    }    
  }
};
</script>

<style lang="scss">
.share-box {
  display: inline-block;
  font-size: 1.4em;
  cursor: pointer;
  color: #717171;
  position: relative;
  .share {
    margin-right: 10px;
  }

  .shareList {
    position: absolute;
    background: white;
    padding: 0;
    border: 1px solid #313131;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    right: 0;  
    top:40px;  
    span {
      font-size: 30px;
      padding: 0 10px;
      margin-top: 5px;
    }
    .icon-weixin_circle{
        color: #11ac36;
    }
    .icon-sign_qq{
        color: #1296db;
    }
  }

  //支付二维码弹出框
    .wx-share-box{
        background: #00000030;
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 120;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        .qrcode{padding:10px 50px;background: white;text-align: center;display: block;margin: 0 auto;border-radius:10px;position: relative;
            .close{width: 40px;height: 40px;position: absolute;right: 10px; top: 10px;cursor: pointer;
                span{color: #3f3f3f;}
            }
            .title{color:#141414;font-size: 1.6em;font-weight: bold;padding: 10px;}
            img{display: block;margin:20px;}
            .desc{padding: 10px;color: #595959;font-size: 14px;}
        }
    }

}
</style>

